import React from 'react';
import './UseCases.scss';

const UseCases: React.FC = () => {
  const cases = [
    {
      icon: '🏗️',
      title: 'Construction & Equipment',
      description: 'Protect expensive machinery, tools, and equipment from theft on job sites',
      features: ['Heavy equipment tracking', 'Tool theft prevention', 'Multi-site management', 'Instant theft alerts']
    },
    {
      icon: '🏍️',
      title: 'Personal Vehicles',
      description: 'Keep your cars, motorcycles, boats, and RVs safe from theft',
      features: ['Theft recovery', 'Movement alerts', 'Parking location memory', 'Teen driver monitoring']
    }
  ];

  return (
    <section className="use-cases">
      <div className="container">
        <h2>Perfect For Every Need</h2>
        <p className="subtitle">Discover how Shadow Tracker protects what matters most</p>
        
        <div className="cases-grid">
          {cases.map((useCase, index) => (
            <div key={index} className="case-card">
              <div className="case-icon">{useCase.icon}</div>
              <h3>{useCase.title}</h3>
              <p className="case-description">{useCase.description}</p>
              <ul className="case-features">
                {useCase.features.map((feature, i) => (
                  <li key={i}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
